module.exports = __webpack_public_path__ + "img/background.9457af2b.png";